import { styled } from 'stitches.config'
import { Text } from 'components/Text'

export const FeatureWrapper = styled('div', {
    display: 'flex',
    justifyContent: 'center',
    gap: 0,
    width: '100%',
    maxWidth: '800px',
    flexWrap: 'wrap',
    margin: 'auto',

    '@bp3': {
      gap: '$2',
    }
  })
  
  export const Feature = styled(Text, {
    width: '277px',
    textAlign: 'center',
    color: '$accent-black',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderColor: '$accent-black',
    letterSpacing: '1px',
    borderRadius: '18px',
    padding: '8px 0px 6px 0px',
    marginTop: '16px',
  
    '@bp3': {
      marginTop: '4px',
      width: '260px',
    },
  })
  